// Where the Splash sends the athlete, and when. SPEC-13, Action list:
// the Splash shows for at least 600 ms and at most as long as the session
// check takes; past 5 s with no answer the athlete gets Boas-vindas anyway,
// and signing in will fail later with its own message.

import type { SessionCheck } from "./session";

export const SPLASH_MIN_MS = 600;
export const SPLASH_MAX_MS = 5000;

/** Signed in: back where she was, Conversa the first time (SPEC-27); otherwise Boas-vindas. */
export type Entry = "signedIn" | "welcome";

const wait = (ms: number) => new Promise<void>((resolve) => setTimeout(resolve, ms));

function answerWithin(checkSession: SessionCheck, ms: number): Promise<Entry> {
  return new Promise((resolve) => {
    const timer = setTimeout(() => {
      console.warn(`[splash] no session answer after ${ms} ms; showing Boas-vindas`);
      resolve("welcome");
    }, ms);
    checkSession().then(
      (signedIn) => resolve(signedIn ? "signedIn" : "welcome"),
      (error: unknown) => {
        console.error("[splash] session check failed; showing Boas-vindas", error);
        resolve("welcome");
      },
    ).finally(() => clearTimeout(timer));
  });
}

export async function decideEntry(checkSession: SessionCheck): Promise<Entry> {
  const [entry] = await Promise.all([
    answerWithin(checkSession, SPLASH_MAX_MS),
    wait(SPLASH_MIN_MS),
  ]);
  return entry;
}
